import cn from './styles.module.sass';

export const HowItWorks = () => {
    return (
        <div className={cn.container}>
            <div className={cn.howItWorksBlock}>
                <div className={cn.dashedLine}></div>
                <div className={cn.blockNumber}>
                    <img src="/images/main/how-it-works/1.svg" alt="" />
                </div>
                <div className={cn.text}>
                    Выбери номер для друга. После оплаты номера, ты получишь 100 Б
                </div>
            </div>
            <div className={cn.howItWorksBlock}>
                <div className={cn.dashedLine}></div>
                <div className={cn.blockNumber}>
                    <img src="/images/main/how-it-works/2.svg" alt="" />
                </div>
                <div className={cn.text}>
                    Получай по 100 Б ежемесячно, пока друг пользуется номером
                </div>
            </div>
            <div className={cn.howItWorksBlock}>
                <div className={cn.blockNumber}>
                    <img src="/images/main/how-it-works/3.svg" alt="" />
                </div>
                <div className={cn.text}>Приглашай друзей, чтобы получать больше бонусов</div>
            </div>
        </div>
    );
};
